export var DocsBlockBehaviorDataType;
(function (DocsBlockBehaviorDataType) {
    /** Item type uses item definition alone to construct items - examples of this are RichText, Shortcut, etc. In this mode, data panel will be hidden */
    DocsBlockBehaviorDataType["item"] = "Item";
    /** Token type allows selection of token entity and associated groups * */
    DocsBlockBehaviorDataType["token"] = "Token";
    /** Asset type allows selection of asset entity and associated groups * */
    DocsBlockBehaviorDataType["asset"] = "Asset";
    /** Component type allows selection of asset entity and associated groups * */
    DocsBlockBehaviorDataType["component"] = "Component";
    /** Figma frame type allows selection of any frame coming from Figma * */
    DocsBlockBehaviorDataType["figmaNode"] = "FigmaNode";
    /** Figma Component type allows selection of any component coming from Figma * */
    DocsBlockBehaviorDataType["figmaComponent"] = "FigmaComponent";
})(DocsBlockBehaviorDataType || (DocsBlockBehaviorDataType = {}));
